import { render, staticRenderFns } from "./LoadingSearch.vue?vue&type=template&id=c3b5775a&"
import script from "./LoadingSearch.vue?vue&type=script&lang=ts&"
export * from "./LoadingSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports